import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchShipping } from "../features/shipping/shippingSlice";

import ShippingForm from "./ShippingForm";
import ShippingTable from "./ShippingTable";

function Shipping() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.shipping
    );

    useEffect(() => {

        dispatch(fetchShipping());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-4">

                    <ShippingForm />

                </div>

                <div className="col-lg-8">

                    <ShippingTable />

                </div>

            </div>

        </div>

    );

}

export default Shipping;